import { Banner, CTA, HorizontalWordLoop } from '@/components'
import mailer from '../../assets/images/blog/telegraph.jpg'
import { Fade, JackInTheBox } from "react-awesome-reveal";
import { Helmet } from 'react-helmet-async';

export const TheTelegraph = () => {

    return <>

        <Helmet>
            <title>Morse Code Academy | The Telegraph</title>
            <meta name="title" content="Morse Code Academy | The Telegraph" />
            <meta
                name="description"
                content="The telegraph was a groundbreaking invention that revolutionized communication in the 19th century. It enabled the rapid transmission of messages across long distances, laying the foundation for modern telecommunications."
            />

            <meta
                property="og:description"
                content="The telegraph was a groundbreaking invention that revolutionized communication in the 19th century. It enabled the rapid transmission of messages across long distances, laying the foundation for modern telecommunications."
            />
            <meta property="og:image" content={mailer} />
            <meta
                property="og:title"
                content="Morse Code Academy | The Telegraph"
            />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://morsecodeacademy.site/blog/the-telegraph" />
        </Helmet>

        <JackInTheBox triggerOnce={true} delay={1000}>
            <Banner
                subtitle={"Learn More About"}
                title={'THE <span class="stroke white">TELEGRAPH</span>'}
                image={mailer}
            // description="Create your software design blueprint with expert software design services."
            />
        </JackInTheBox>

        <div className="">
            <div className="container">
                <div className="row pt-5 align-items-center justify-content-center justify-content-lg-start ">
                    <div className="col-lg-12 mt-lg-0 mt-3">
                        <Fade triggerOnce={true}>
                            <h3 className='text-primary'>Introduction</h3>
                            <p className="text-white mt-3 ">
                                The telegraph was a groundbreaking invention that revolutionized communication in the 19th century. It enabled the rapid transmission of messages across long distances, laying the foundation for modern telecommunications.
                            </p>
                        </Fade>

                        <Fade triggerOnce={true}>
                            <h3 className='text-primary mt-3'>
                                Development
                            </h3>
                            <p className="text-white mt-3 ">
                                The first practical telegraph system was developed by Samuel Morse and his collaborators in the 1830s and 1840s. Their system used electrical signals transmitted over wires to convey messages. These signals were encoded using a system of dots and dashes, known as Morse code.
                            </p>
                        </Fade>
                    </div>
                </div>
            </div>
        </div>
        <Fade triggerOnce={true} delay={100}>
            <HorizontalWordLoop title={"THE TELEGRAPH"} />
        </Fade>
        <div className="container">
            <div className="row pb-5 align-items-center justify-content-center justify-content-lg-start ">
                <Fade triggerOnce={true}>
                    <h3 className='text-primary  mt-3'>
                        How It Works
                    </h3>
                    <p className="text-white mt-3 ">
                        The telegraph system consisted of a transmitter, a receiver, and a line connecting them. Operators would use a telegraph key to send electrical pulses along the wire. These pulses represented letters and numbers when decoded. The receiver would then transcribe the pulses into written messages.
                    </p>
                </Fade>

                <Fade triggerOnce={true}>
                    <h3 className='text-primary  mt-3'>
                        Impact
                    </h3>
                    <p className="text-white mt-3 ">
                        The introduction of the telegraph transformed industries and societies by enabling instant communication. It played a crucial role in commerce, journalism, and even warfare. For example, the telegraph allowed for faster coordination during military campaigns and expedited the dissemination of news.
                    </p>
                </Fade>

                <Fade triggerOnce={true}>
                    <h3 className='text-primary  mt-3'>
                        Legacy
                    </h3>
                    <p className="text-white mt-3 ">
                        Although the telegraph has been largely replaced by more advanced technologies, its legacy endures as a pivotal step in the evolution of communication. The principles of the telegraph influenced later innovations, including the telephone and the internet.
                    </p>
                </Fade>
            </div>
        </div>
        {/* <div className="container py-5">
            <div className="row">
                <div className="col-12">
                    <Slide delay={200} ><h4 className='text-primary  pb-2'>Things You Should Know About</h4></Slide>
                    <Slide delay={400} ><h2 className='text-primary pt-1'>Custom Software Design</h2></Slide>
                </div>

                <div className="col-12 mt-3">
                    <Fade triggerOnce={true}>
                        <Accordion
                            delay={1000}
                            title={"How much does custom software cost?"}
                            children={"<p class='text-white pb-3'>Costs vary by size and scope of the project. Click to read the different variables that can affect your project.</p>"}
                        />

                        <Accordion
                            delay={1200}
                            title={"How long will my project take?"}
                            children={"<p class='text-white pb-3'>No two projects are alike or take the same amount of time to build. The size and complexity of the project are the biggest factors in overall duration. Click to read more.</p>"}
                        />

                        <Accordion
                            delay={1400}

                            title={"I have an idea, now what?"}
                            children={"<p class='text-white pb-3'>Having a new software development idea can be exciting. Click to see our 6 Steps On How To Get Started With Your Software Idea.</p>"}
                        />

                        <Accordion
                            delay={1600}
                            title={"What can delay my custom software project?"}
                            children={"<p class='text-white pb-3'>Software projects often take longer than planned. Click for the common reasons why projects run over their initial time estimates.</p>"}
                        />

                        <Accordion
                            delay={1800}
                            title={"How do I turn a troubled project around?"}
                            children={"<p class='text-white pb-3'>There are many ways a software project can go wrong. What you do to turn the project around can make all the difference. Click to read how to get the project back on track.</p>"}
                        />
                    </Fade>
                </div>
            </div>
        </div> */}
        <CTA
            title={"Bridging <span class='stroke'>Ideas</span><br>To <span class='stroke '>Solutions</span>"}
            description={"Are you ready to start a new software development project? Work with our team of software designers and developers. It’s never too early, or too late, to bring your idea to life."} />


    </>

}
